// Simple email preset for 600x1500 dimensions

export const email = {
	name: 'Untitled Email Template',
	variant: 'email',
	json: {
		width: 600,
		height: 1500,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
			},
		],
		unit: 'px',
		dpi: 96,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	// Email templates default to the single required type tag only. Other tags
	// remain allowed and can be added in the save modal, but we no longer
	// pre-populate Medium/Layout — the minimum is just type:email.
	tags$General: ['0:Type:Email'],
	etc: {
		directives: {},
		cfg: {
			global: {
				minPages: 1,
				maxPages: 1,
			},
			customer: {
				minPages: 1,
				maxPages: 1,
			},
			order: {
				countries: null,
				itemId: 'email',
			},
			canBeResized: false,
		},
	},
};

export default email;
